import { createContext, useState } from 'react';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';

type NoteContextType = {
  noteDrawerOpen: boolean;
  setNoteDrawerOpen: (noteDrawerOpen: boolean) => void;
  message: string;
  setMessage: (message: string) => void;
  fetchNote: () => Promise<void>;
};

export const NoteContext = createContext<NoteContextType>(null!);

export const NoteProvider: React.FC = ({ children }) => {
  const [noteDrawerOpen, setNoteDrawerOpen] = useState(false);
  const [message, setMessage] = useState('');

  const { room } = useVideoContext();

  const fetchNote = async () => {
    try {
      const endpoint = `${process.env.REACT_APP_TOKEN_ENDPOINT}/work-orders/call/note?room=${room?.name}`;

      const res = await fetch(endpoint, {
        headers: {
          'content-type': 'application/json',
          accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('portal_token'),
        },
      });

      if (res.status === 200) {
        res.json().then(data => {
          setMessage(data.result.note);
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <NoteContext.Provider
      value={{
        noteDrawerOpen,
        setNoteDrawerOpen,
        message,
        setMessage,
        fetchNote,
      }}
    >
      {children}
    </NoteContext.Provider>
  );
};
